import { SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

const IndicatorCard: FC = () => (
  <div className="border rounded-lg p-4 flex flex-col gap-3 grow basis-0 min-w-sm max-w-xl">
    <div className="flex items-center gap-2">
      <SkeletonLoader.Square className="h-5 w-5 rounded" />
      <SkeletonLoader.Text className="h-4 w-32" />
    </div>
    <SkeletonLoader className="h-16 w-full rounded" />
    <div className="flex items-center justify-between">
      <SkeletonLoader.Text className="h-4 w-24" />
      <SkeletonLoader.Text className="h-4 w-20" />
    </div>
  </div>
);

const AutomationRow: FC = () => (
  // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Mixed grid template has no utility
  <div className="grid grid-cols-[2fr_1fr_1fr_auto_auto] gap-4 px-4 py-4 border-b last:border-b-0 items-center">
    <SkeletonLoader.Text className="h-4 w-64" />
    <SkeletonLoader.Text className="h-4 w-24" />
    <SkeletonLoader.Text className="h-4 w-28" />
    <SkeletonLoader className="h-6 w-10 rounded-full" />
    <SkeletonLoader.Square className="h-5 w-5" />
  </div>
);

const AutomationsPageSkeleton: FC = () => (
  <div className="flex flex-col h-full">
    <div className="flex items-center gap-6 px-4 border-b">
      <div className="py-3">
        <SkeletonLoader.Text className="h-4 w-24" />
      </div>
      <div className="py-3">
        <SkeletonLoader.Text className="h-4 w-28" />
      </div>
    </div>

    <div className="p-4">
      <div className="flex flex-row flex-wrap gap-8 w-full">
        <IndicatorCard />
        <IndicatorCard />
      </div>
    </div>

    <div className="px-4 pb-4">
      <div className="border rounded-lg overflow-hidden">
        {/* oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Mixed grid template has no utility */}
        <div className="grid grid-cols-[2fr_1fr_1fr_auto_auto] gap-4 px-4 py-3 border-b bg-gray-50">
          <SkeletonLoader.Text className="h-4 w-20" />
          <SkeletonLoader.Text className="h-4 w-16" />
          <SkeletonLoader.Text className="h-4 w-16" />
          <SkeletonLoader.Text className="h-4 w-12" />
          <SkeletonLoader.Square className="h-4 w-4" />
        </div>
        {Array.from({ length: 8 }).map((_, i) => (
          <AutomationRow key={i} />
        ))}
      </div>
    </div>
  </div>
);

export default AutomationsPageSkeleton;
